/**
 * DisplayItem > Strategy object.
 *
 * @typedef {Object} Strategy
 * @namespace
 *
 * @memberof Common.Model.Entity.DisplayItem
 *
 * @property {String} displayStrategy The display strategy (prominence) for the item (eg. show|feature|spotlight)
 * @property {String} detailsStrategy Unknown!
 */
class Strategy {

	constructor(displayStrategy, detailsStrategy) {

		this.displayStrategy	= displayStrategy;
		this.detailsStrategy	= detailsStrategy;
	}
}

export default Strategy;